module.exports = __webpack_public_path__ + "img/广州骅星.7fc1b7c6.jpg";